import { render, staticRenderFns } from "./FormularioAgregarLibro.vue?vue&type=template&id=34c4ebe4&"
import script from "./FormularioAgregarLibro.vue?vue&type=script&lang=js&"
export * from "./FormularioAgregarLibro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports